// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../img/backgrounds/2023-saved.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2734%27 height=%2735%27 viewBox=%270 0 34 35%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M33.8112 34.0045L27.3897 34.0045C27.2853 34.0045 27.2009 33.92 27.2009 33.8157L27.2009 30.415C27.2009 30.3106 27.1165 30.2262 27.0121 30.2262L20.5906 30.2262C20.4862 30.2262 20.4018 30.1418 20.4018 30.0374L20.4018 26.6367C20.4018 26.5323 20.3174 26.4479 20.213 26.4479L13.7915 26.4479C13.6871 26.4479 13.6027 26.3635 13.6027 26.2591L13.6027 22.8584C13.6027 22.754 13.5183 22.6696 13.4139 22.6696L6.99236 22.6696C6.88796 22.6696 6.80355 22.5852 6.80355 22.4808L6.80355 19.0802C6.80355 18.9758 6.71915 18.8914 6.61475 18.8914L0.188802 18.8914C0.0844052 18.8914 -6.64303e-07 18.807 -6.68867e-07 18.7026L-8.17515e-07 15.3019C-8.22078e-07 15.1975 0.084405 15.1131 0.188802 15.1131L6.61031 15.1131C6.7147 15.1131 6.79911 15.0287 6.79911 14.9243L6.79911 11.5236C6.79911 11.4192 6.88352 11.3348 6.98791 11.3348L13.4094 11.3348C13.5138 11.3348 13.5982 11.2504 13.5982 11.146L13.5982 7.74536C13.5982 7.64096 13.6826 7.55656 13.787 7.55656L20.2085 7.55656C20.3129 7.55656 20.3973 7.47215 20.3973 7.36775L20.3973 3.96709C20.3973 3.86269 20.4817 3.77829 20.5861 3.77829L27.0076 3.77828C27.112 3.77828 27.1964 3.69388 27.1964 3.58948L27.1964 0.188815C27.1964 0.0844181 27.2808 1.40663e-05 27.3852 1.40617e-05L33.8067 1.3781e-05C33.9111 1.37765e-05 33.9956 0.0844178 33.9956 0.188815L33.9956 33.8157C33.9956 33.92 33.9111 34.0045 33.8068 34.0045L33.8112 34.0045Z%27 fill=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carouselContentWrapper--V5GMD {
  background-color: #0e3b83;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #ffffff;
  background-position-x: 85%;
}

.carouselItem--T58w5 {
  width: auto;
}

.title--F0Ijm {
  color: white;
  font-style: normal;
  font-weight: 600;
  font-size: 35px;
  line-height: 42px;
}

.description--SKCoI {
  color: white;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
}

[dir] .description--SKCoI {
  text-align: center;
}

.viewButton--tGHc7 {
  color: #e6512d;
}

[dir] .viewButton--tGHc7 {
  margin: 20px 0 0 0;
  border-color: #e6512d;
  background: #ffffff;
}

.previousArrow--nmyFn,
.nextArrow--Fs_93 {
  opacity: 0.5;
  width: 34px;
  height: 34px;
  top: 50%;
}

[dir] .previousArrow--nmyFn, [dir] .nextArrow--Fs_93 {
  cursor: pointer;
  background: 50%/100% 100% no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.previousArrow--nmyFn:hover,
.nextArrow--Fs_93:hover {
  opacity: 1;
}
.nextArrow--Fs_93 {
  position: absolute;
  right: 10%;
  transform: rotate(180deg);
}
.previousArrow--nmyFn {
  position: absolute;
  left: 10%;
  z-index: 99;
}

@media screen and (min-width: 768px) {
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SavedViewsCarousel/styles.css"],"names":[],"mappings":"AACA;EACE,yBAAyB;EACzB,yDAAgE;EAChE,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AAEnB;;AAPA;EAME,kBAAkB;AACpB;;AAEA;EAEE,cAAc;AAGhB;;AALA;EACE,kBAAkB;EAElB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,YAAY;EAEZ,QAAQ;AAGV;;AATA;EAKE,eAAe;EAEf,mCAAmC;EACnC,yDAA4/C;AAC9/C;;AAEA;;EAEE,UAAU;AACZ;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;AACA","sourcesContent":["/* rtl:ignore */\n.carouselContentWrapper {\n  background-color: #0e3b83;\n  background-image: url('../../../img/backgrounds/2023-saved.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  padding: 40px 0;\n  color: #ffffff;\n  background-position-x: 85%;\n}\n\n.carouselItem {\n  width: auto;\n}\n\n.title {\n  color: white;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 35px;\n  line-height: 42px;\n}\n\n.description {\n  color: white;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  text-align: center;\n}\n\n.viewButton {\n  margin: 20px 0 0 0;\n  color: #e6512d;\n  border-color: #e6512d;\n  background: #ffffff;\n}\n\n.previousArrow,\n.nextArrow {\n  opacity: 0.5;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  top: 50%;\n  background: 50%/100% 100% no-repeat;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='34' height='35' viewBox='0 0 34 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M33.8112 34.0045L27.3897 34.0045C27.2853 34.0045 27.2009 33.92 27.2009 33.8157L27.2009 30.415C27.2009 30.3106 27.1165 30.2262 27.0121 30.2262L20.5906 30.2262C20.4862 30.2262 20.4018 30.1418 20.4018 30.0374L20.4018 26.6367C20.4018 26.5323 20.3174 26.4479 20.213 26.4479L13.7915 26.4479C13.6871 26.4479 13.6027 26.3635 13.6027 26.2591L13.6027 22.8584C13.6027 22.754 13.5183 22.6696 13.4139 22.6696L6.99236 22.6696C6.88796 22.6696 6.80355 22.5852 6.80355 22.4808L6.80355 19.0802C6.80355 18.9758 6.71915 18.8914 6.61475 18.8914L0.188802 18.8914C0.0844052 18.8914 -6.64303e-07 18.807 -6.68867e-07 18.7026L-8.17515e-07 15.3019C-8.22078e-07 15.1975 0.084405 15.1131 0.188802 15.1131L6.61031 15.1131C6.7147 15.1131 6.79911 15.0287 6.79911 14.9243L6.79911 11.5236C6.79911 11.4192 6.88352 11.3348 6.98791 11.3348L13.4094 11.3348C13.5138 11.3348 13.5982 11.2504 13.5982 11.146L13.5982 7.74536C13.5982 7.64096 13.6826 7.55656 13.787 7.55656L20.2085 7.55656C20.3129 7.55656 20.3973 7.47215 20.3973 7.36775L20.3973 3.96709C20.3973 3.86269 20.4817 3.77829 20.5861 3.77829L27.0076 3.77828C27.112 3.77828 27.1964 3.69388 27.1964 3.58948L27.1964 0.188815C27.1964 0.0844181 27.2808 1.40663e-05 27.3852 1.40617e-05L33.8067 1.3781e-05C33.9111 1.37765e-05 33.9956 0.0844178 33.9956 0.188815L33.9956 33.8157C33.9956 33.92 33.9111 34.0045 33.8068 34.0045L33.8112 34.0045Z' fill='white'/%3E%3C/svg%3E%0A\");\n}\n\n.previousArrow:hover,\n.nextArrow:hover {\n  opacity: 1;\n}\n\n/* rtl:ignore */\n.nextArrow {\n  position: absolute;\n  right: 10%;\n  transform: rotate(180deg);\n}\n\n/* rtl:ignore */\n.previousArrow {\n  position: absolute;\n  left: 10%;\n  z-index: 99;\n}\n\n@media screen and (min-width: 768px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselContentWrapper": `carouselContentWrapper--V5GMD`,
	"carouselItem": `carouselItem--T58w5`,
	"title": `title--F0Ijm`,
	"description": `description--SKCoI`,
	"viewButton": `viewButton--tGHc7`,
	"previousArrow": `previousArrow--nmyFn`,
	"nextArrow": `nextArrow--Fs_93`
};
export default ___CSS_LOADER_EXPORT___;
